SA.ArrowPopup = class {
    get tpl() {
        return [
            '<div class="sa-arrow-popup-arrow"></div>',
            '<div class="sa-arrow-popup-content"></div>'
        ].join('');
    }

    constructor({content, placement = 'auto', target}) {
        this.onWindowMouseDown = this.onWindowMouseDown.bind(this);

        this.el = document.body.appendChild(this.createEl({content}));
        this.popperInstance = this.createPopper({placement, target});
        this.target = target;

        addEventListener('mousedown', this.onWindowMouseDown);
    }

    createEl({content}) {
        var el = document.createElement('div');

        el.classList.add('sa-arrow-popup');
        el.innerHTML = this.tpl;
        el.querySelector('.sa-arrow-popup-content').appendChild(content);

        return el;
    }

    createPopper({placement, target}) {
        return Popper.createPopper(target, this.el, {
            placement,

            modifiers: [
                {
                    name: 'arrow',

                    options: {
                        element: '.sa-arrow-popup-arrow',
                        padding: 5
                    }
                }, {
                    name: 'offset',
                    options: {offset: [0, 7]}
                }
            ]
        });
    }

    destroy() {
        this.fireEvent(new Event('destroy'));

        removeEventListener('mousedown', this.onWindowMouseDown);

        this.popperInstance.destroy();
        this.el.remove();
    }

    fireEvent(ev) {
        this.el.dispatchEvent(ev);
    }

    on(type, listener, scope) {
        this.el.addEventListener(type, listener.bind(scope));
    }

    onWindowMouseDown(ev) {
        if (!this.el.contains(ev.target) && !this.target.contains(ev.target)) {
            this.destroy();
        }
    }
};